import axios from 'axios'

export default {
    getImages({ dispatch, commit }, data) {
        axios
            .get('/api/ControlPanel/GetGalleryImages')
            .then(response => {
                commit('SET_IMAGES_RESULT', response.data.data.$values)
            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },

    getContentCategory({ dispatch, commit }, data) {
        axios
            .get('/api/ControlPanel/GetContentCategory')
            .then(response => {
                commit('SET_ContentCategory_RESULT', response.data.data.$values)

            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },
    async getContentByCategoryRef({ dispatch, commit }, data) {
        await axios
            .get('/api/ControlPanel/getContentByCategoryRef?CategoryRef=' + data)
            .then(response => {
                commit('SET_ContentByCategoryRef_RESULT', response.data.data)

            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },
    async getContentListByCategoryRef({ dispatch, commit }, data) {
        await axios
            .get('/api/ControlPanel/getContentListByCategoryRef?CategoryRef=' + data)
            .then(response => {
                commit('SET_ContentListByCategoryRef_RESULT', response.data.data)

            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },
    async getContentListByCategoryTitle({ dispatch, commit }, data) {
        await axios
            .get('/api/ControlPanel/getContentListByCategoryTitle?CategoryTitle=' + data)
            .then(response => {
                if (data == "FAQ") { commit('SET_ContentListByCategoryFAQ_RESULT', response.data.data) }
                if (data == "Comments") { commit('SET_ContentListByCategoryComments_RESULT', response.data.data) }
                if (data == "Articles") { commit('SET_ContentListByCategoryArticles_RESULT', response.data.data) }

            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },
    async addOrUpdateContent({ dispatch, commit }, data) {
        await axios
            .post('/api/ControlPanel/addOrUpdateContent', data)
            .then(response => {
                dispatch('successPOSTHandler', response, { root: true });
            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },
    async deleteContent({ dispatch, commit }, data) {
        await axios
            .delete('/api/ControlPanel/deleteContent/' + data)
            .then(response => {
                dispatch('successPOSTHandler', response, { root: true });
            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },

}